export const ASSISTANT_TEMPLATE_SELECTION_EVENT =
  'assistant-template-selection-change';

const ASSISTANT_TEMPLATE_SELECTION_KEY = 'assistantTemplateSelection';

export function getAssistantTemplateSelection() {
  if (typeof window === 'undefined') return null;

  try {
    const value = localStorage.getItem(ASSISTANT_TEMPLATE_SELECTION_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

export function setAssistantTemplateSelection(selection) {
  if (typeof window === 'undefined') return;

  try {
    if (selection) {
      localStorage.setItem(
        ASSISTANT_TEMPLATE_SELECTION_KEY,
        JSON.stringify(selection)
      );
    } else {
      localStorage.removeItem(ASSISTANT_TEMPLATE_SELECTION_KEY);
    }
  } catch {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(ASSISTANT_TEMPLATE_SELECTION_EVENT, {
      detail: { selection },
    })
  );
}
